function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M5.078 18.621 11.04 4.62c.217-.51.823-.754 1.353-.545.256.102.46.298.565.545l5.963 14.001a.987.987 0 0 1-.565 1.304c-.357.141-.765.08-1.06-.159l-3.964-3.207a2.13 2.13 0 0 0-2.666 0l-3.964 3.207c-.438.355-1.092.3-1.46-.123a.97.97 0 0 1-.165-1.022",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-navigation.svg";
export { SvgComponent as ReactComponent };